import { render, staticRenderFns } from "./fileTag.vue?vue&type=template&id=630f236f"
import script from "./fileTag.vue?vue&type=script&lang=js"
export * from "./fileTag.vue?vue&type=script&lang=js"
import style0 from "./fileTag.vue?vue&type=style&index=0&id=630f236f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports